import { supabase } from "@/integrations/supabase/client";

// Generate or get session ID from sessionStorage
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('kopfai_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('kopfai_session_id', sessionId);
  }
  return sessionId;
};

export const useKopfaiClickTracking = () => {
  const trackClick = async (
    source: string,
    postId?: number | null,
    buttonText?: string
  ) => {
    try {
      const sessionId = getSessionId();
      const pageUrl = window.location.href;

      await supabase.from('kopfai_clicks').insert({
        post_id: postId || null,
        source,
        button_text: buttonText || 'Conhecer a KopfAI',
        page_url: pageUrl,
        session_id: sessionId,
      });
    } catch (error) {
      console.error('Error tracking click:', error);
    }
  };

  return { trackClick };
};
